import { render, staticRenderFns } from "./Cog.vue?vue&type=template&id=1b852f02&functional=true&"
import script from "./Cog.vue?vue&type=script&lang=js&"
export * from "./Cog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b852f02')) {
      api.createRecord('1b852f02', component.options)
    } else {
      api.rerender('1b852f02', component.options)
    }
    module.hot.accept("./Cog.vue?vue&type=template&id=1b852f02&functional=true&", function () {
      api.rerender('1b852f02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-material-design-icons/Cog.vue"
export default component.exports